/**
 * Scoring: 2 points per animal, plus combo bonus when catching 2 in a row.
 * Same submission model as catch-the-train: each client submits their total points; server keys by player id.
 */
export const POINTS_PER_ANIMAL = 2;
export const COMBO_BONUS = 5;
/** Time window (ms) for "2 in a row": if last catch was within this, current catch gets combo bonus. */
export const COMBO_WINDOW_MS = 1800;

/** Total points from count only (no combo). Used for display fallback. */
export function getPointsForAnimalCount(animalCount: number): number {
  return animalCount * POINTS_PER_ANIMAL;
}

/** Game tuning: fall speed, platform, spawn rate. */
export const SAVE_THE_ANIMALS_CONFIG = {
  /** Base fall speed in % of container height per second; each animal gets a random multiplier. */
  fallSpeedPerSecond: 1.2,
  /** Min/max multiplier for per-animal fall speed (e.g. 0.75 = slower, 1.35 = faster). */
  fallSpeedMultiplierMin: 0.75,
  fallSpeedMultiplierMax: 1.35,
  /** Spawn interval in ms (smaller = more animals). */
  spawnIntervalMs: 650,
  /** Spawn 1 or 2 animals per tick (random) for more density. */
  spawnCountMax: 2,
  /** Platform width as fraction of container (0–1); slightly smaller = harder. */
  platformWidthFraction: 0.24,
  /** Platform height (px). */
  platformHeightPx: 28,
  /** Animal emoji size (px). */
  emojiSizePx: 42,
  /** Hit margin: animal counts as caught if within this fraction of platform center. */
  catchMarginFraction: 0.15,
  /** Height of the bottom strip that holds the platform (px). Platform sits at top of this strip. */
  platformStripHeightPx: 70,
  /** Fence width (px). */
  fenceWidthPx: 6,
} as const;
